export const FOUR_DECIMAL_PLACES = 4;



// WEBPACK FOOTER //
// ./src/components/purchase_limits/purchase_limits_const.js